import { createCRUDHook } from './createCRUDHook';
import { TimeClockDto, FilterOptionModel, StaffDto } from 'utils/models';
import {
  FILTERED_ENTITIES,
  GET_NOT_CLOCKED_INACTIVE_USER_LIST,
  GET_TIME_CLOCK_REPORT_DATA,
  TIME_CLOCK,
} from './apiEndPoints';
import { prepareQueryParams } from 'utils';

interface TimeClockCustomOperations {
  GetTimeClockReportData: (
    startDate: string,
    endDate: string
  ) => Promise<TimeClockDto[]>;

  GetNotClockedInActiveUserList: () => Promise<StaffDto[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  TimeClockDto,
  TimeClockDto[],
  TimeClockCustomOperations
>({
  entityName: 'TimeClock',
  endpoint: TIME_CLOCK,

  customOperations: (auth) => ({
    GetTimeClockReportData: async (
      startDate: string,
      endDate: string
    ): Promise<TimeClockDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TIME_CLOCK +
            GET_TIME_CLOCK_REPORT_DATA +
            `?startDate=${startDate}&endDate=${endDate}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    GetNotClockedInActiveUserList: async (): Promise<StaffDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TIME_CLOCK + GET_NOT_CLOCKED_INACTIVE_USER_LIST
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const TimeClockContext = Context;
export const useTimeClockManager = useManager;
export const useTimeClock = useConsumer;
